import { render, staticRenderFns } from "./addPersonPhone.vue?vue&type=template&id=c84dcf90&scoped=true&"
import script from "./addPersonPhone.vue?vue&type=script&lang=js&"
export * from "./addPersonPhone.vue?vue&type=script&lang=js&"
import style0 from "./addPersonPhone.vue?vue&type=style&index=0&id=c84dcf90&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84dcf90",
  null
  
)

export default component.exports